// extracted by mini-css-extract-plugin
export var borderRadius = "_6b-4";
export var large = "_6b-3";
export var logoContainer = "_6b-0";
export var nameLogo = "_6b-2";
export var small = "_6b-1";